import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment }  from '../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class EmployeeService {
	


  private  baseUrl=environment.baseUrl+"/";
   

  constructor(private http:HttpClient) { }

  uploadFile(file: File): Observable<HttpEvent<{}>> {
		const formdata: FormData = new FormData();
		formdata.append('file', file);
		const req = new HttpRequest('POST', `${this.baseUrl}upload`, formdata, {
			  reportProgress: true,
			  responseType: 'text'
		});
	
		return this.http.request(req);
   }
   uploadMultipleEmployee(file: File): Observable<HttpEvent<{}>> {
		const formdata: FormData = new FormData();
		formdata.append('file', file);
		const req = new HttpRequest('POST', `${this.baseUrl}uploadmultipleemployee`, formdata, {
			  reportProgress: true,
			  responseType: 'text'
		});
	
		return this.http.request(req);
   }
   uploadItems(file: File,sheet: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('filesToProcess',sheet);

    const req = new HttpRequest('POST', `${this.baseUrl}upload`, formData, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);
  }
   
  getEmployeeList(): Observable<any> {
    return this.http.get(`${this.baseUrl}`+'employees-list');
  }

  createEmployee(employee: object): Observable<object> {
    
    return this.http.post(`${this.baseUrl}`+'employee', employee);
  }

  deleteEmployee(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}employee/${id}`, { responseType: 'text' });
  }

  getEmployee(id: number): Observable<Object> {
    
    return this.http.get(`${this.baseUrl}employee/${id}`);
  }

  updateEmployee(id: number, value: any): Observable<Object> {
    return this.http.post(`${this.baseUrl}update-employee/${id}`, value);
  }
  downloadFile(url: string): Observable<Object> {
    console.log(JSON.stringify(url));
		return this.http.get(`${this.baseUrl}item/download/${url}`, {responseType: 'blob'});
  }

  getInventoryByName(url: string): Observable<Object> {
    return this.http.get(`${this.baseUrl}employeeByName/${url}`);
  }


  getItemList(): Observable<any> {
    return this.http.get(`${this.baseUrl}`+'item-list');
  }
  getInventoryList(): Observable<any> {
     return this.http.get(`${this.baseUrl}`+'inventory-list');
  }
  getInventoryListNew(id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}`+'items/employee/'+id);
  }
  removeInventoryItems(itemids: any): Observable<Object>{
    console.log('service' +JSON.stringify(itemids));
    return this.http.delete(`${this.baseUrl}`+`item/${itemids}`, {responseType: 'text'});
  }
  removeInvByNameItem(name: string,itemid: string): Observable<Object>{
    const formData: FormData = new FormData();

    formData.append('itemid', itemid);
    formData.append('name', name);

    const req = new HttpRequest('POST', `${this.baseUrl}deleteInvByNameItem`, formData, {
      responseType: 'text'
    });

    return this.http.request(req);
    }
  uploadAssignment(file: File,name:string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('name', name);

    console.log('service' +formData);
     console.log('Employee Service BaseURL =========>'+this.baseUrl);
    const req = new HttpRequest('POST', `${this.baseUrl}uploadAssignment`, formData, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);
  }
  uploadApprovalItems(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.baseUrl}uploadapprovalitems`, formData, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);
  }
  getAprovalStatusList(): Observable<any> {
    return this.http.get(`${this.baseUrl}`+'orders/distinctOrderedDates');
  }
  
  
  getApprovalStatusBydate(url: Date): Observable<Object> {
    return this.http.get(`${this.baseUrl}orders?date=${url}`);
  }

  getApprovalItemsById(id: number): Observable<Object> {
    return this.http.get(`${this.baseUrl}getApprovalItemsById/${id}`);
  }

  updateReorderApprovalItems(approvalId: any,status: any,itemId:any,notesi: any): Observable<Object>{

    console.log('service' +JSON.stringify(approvalId));
    console.log('service' +JSON.stringify(status));
    console.log('service' +JSON.stringify(itemId));
        console.log('notesi' +JSON.stringify(notesi));
    const formData: FormData = new FormData();

    formData.append('approvalId', approvalId);
    formData.append('status', status);
    formData.append('itemId', itemId);
	formData.append('notesi', notesi);

    console.log('service' +formData);
    const req = new HttpRequest('POST', `${this.baseUrl}updateReorderApprovalItems`, formData, {
      responseType: 'text'
    });

    return this.http.request(req);
    }

    updateReorderApproval(obj:any, orderId:any): Observable<Object>{

      /*console.log('service' +JSON.stringify(approvalId));
      console.log('service' +JSON.stringify(notes));
      const formData: FormData = new FormData();
  
      formData.append('approvalId', approvalId);
      formData.append('notes', notes);
  
      console.log('service' +formData);*/
      const req = new HttpRequest('put', `${this.baseUrl}order/${orderId}`, obj, {
        responseType: 'text'
      });
  
      return this.http.request(req);
      }
  
      updateInventryAssign(empid:any, items: any):  Observable<Object>{
        const obj = {
          'empId': empid,
          'itemIds': items
        };
        const req = new HttpRequest('PUT', `${this.baseUrl}items`, obj, {
          responseType: 'text'
        });
        return this.http.request(req);
      }
      getOrders(id: number): Observable<Object> {
        return this.http.get(`${this.baseUrl}orders/${id}`)
      }
      getItemsById(id: number): Observable<Object> {
        return this.http.get(`${this.baseUrl}items/${id}`);
      }
}                                           